/**
 * wrapHelper
 * @function wrapHelper
 * @param {object} el
 * @param {object} wrapper
 */
const wrapHelper = (el, wrapper) => {
	el.parentNode.insertBefore(wrapper, el);
	wrapper.appendChild(el);
	wrapper.classList.add('bl-img-wrapper');
};

export default wrapHelper;